import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import theme, { largeTitle as titleStyle } from '../../styles/theme';
import Tiles from './Tiles';
import Title from '../Title';
import { getSliceContent, getSliceCopy, getSliceTitleAndTag } from '../../selectors';
import get from '../../helpers/get';

const OurBrands = ({
  className,
  classes,
  copy,
  sliceId,
  title,
  titleTag,
  isStackedOnMobile,
  hideExtraStakedItems,
}) => (
  <div className={cn(className, classes.ourBrands)}>
    <Title className={classes.title} tag={titleTag}>
      {title}
    </Title>
    <p className={classes.copy}>
      {copy}
    </p>
    <Tiles
      sliceId={sliceId}
      isStackedOnMobile={isStackedOnMobile}
      hideExtraStakedItems={hideExtraStakedItems}
    />
  </div>
);

OurBrands.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  copy: PropTypes.string,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
  isStackedOnMobile: PropTypes.bool,
  hideExtraStakedItems: PropTypes.bool,
};

OurBrands.defaultProps = {
  className: undefined,
  copy: undefined,
  title: undefined,
  titleTag: 'h2',
  isStackedOnMobile: false,
  hideExtraStakedItems: false,
};

const mapStateToProps = (state, { sliceId }) => ({
  ...getSliceTitleAndTag(state, sliceId),
  copy: getSliceCopy(state, sliceId),
  isStackedOnMobile: get(getSliceContent(state, sliceId), ['stack_on_mobile']) === 'Stacked',
  hideExtraStakedItems: get(getSliceContent(state, sliceId), ['hide_extra_stacked_items']) === 'Yes',
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    title: {
      ...titleStyle,
      marginBottom: 3,
    },
    copy: {
      fontSize: 16,
      lineHeight: '24px',
      margin: [0, 0, 8],
      color: theme.colors.brandBlack,
      fontFamily: theme.fonts.body,
      'div p&': {
        fontFamily: theme.fonts.body,
      },
    },
  }),
)(OurBrands);
